const defaultStub = {
  mysql: `use DoSelect;
# Write your sql queries here`,
  postgresql: `\\c "DoSelect";
-- Write your sql queries here`,
  oracle: `alter session set current_schema = doselect;
SET heading OFF
-- Write your sql queries here`,
  mongodb: `conn = new Mongo()
db = conn.getDB("test")`,
  mssql: `USE northwind;`,
};

export default defaultStub;
